import React from 'react';
import { NewsSection as RawNewsSection } from '../../../components/landingPage/NewsSection';
import { SanityObject } from '../../../lib/landingPage';
import { Image, ImageProps } from '../Image';
import { ButtonLink, ButtonLinkProps } from '../Link';
import { Wrapper } from '../Wrapper';

type NewsMentionProps = {
    logo: SanityObject<ImageProps>;
    link: SanityObject<ButtonLinkProps>;
    title: string;
};

const NewsMention = Wrapper(({ logo, link, title }: NewsMentionProps) => {
    return (
        <RawNewsSection.Mention
            logo={<Image value={logo} />}
            link={<ButtonLink value={link} />}>
            {title}
        </RawNewsSection.Mention>
    );
}, 'newsMention');

export type NewsSectionProps = {
    title: string;
    subtitle: string;
    articles: SanityObject<NewsMentionProps>[];
};

export const NewsSection = Wrapper(
    ({ title, subtitle, articles }: NewsSectionProps): JSX.Element => {
        return (
            <RawNewsSection title={title} subtitle={subtitle}>
                <NewsMention value={articles} />
            </RawNewsSection>
        );
    },
    'newsSection'
);
